var {AmpersandApp: productCatalogApp, AmpersandView} = require('catalog/libs');
var HPESpinner = require('styleguide/spinner').default;

var HPEConstants = require('../../../base/hpe.constants');

var UtilityBarView = require('./hpe.productlist.utilitybar.view');
var PaginationView = require('./hpe.productlist.pagination.view');
var ProductCardView = require('./hpe.productlist.productcard.view');
var FiltersView = require('./hpe.productlist.filterlist.view');
var BreadcrumbsView = require('./hpe.productlist.breadcrumb.view');
var template = require('../templates/hpe.productlist.app.template.tpl');

var ProductCatalogView = AmpersandView.extend({

    template: template,

    /**
     * initialization
     */
    initialize: function() {

        //event listeners
        this.onResize = this.onWindowResize.bind(this);
        productCatalogApp.on(HPEConstants.catalog.VIEW_UPDATE_REQUEST, this.onCatalogViewUpdateRequest, this);
        productCatalogApp.on(HPEConstants.catalog.VIEW_UPDATE_RENDER, this.onCatalogViewUpdateRender, this);
        window.addEventListener('resize', this.onResize);

        this.render();
    },

    /**
     * render
     */
    render: function() {
        this.renderWithTemplate(this);
        this.viewCachingInitialize();
    },

    /**
     * view destructor
     */
    destroy: function() {

        this.filters.destroy();

        //remove event listeners
        productCatalogApp.off(HPEConstants.catalog.VIEW_UPDATE_REQUEST, this.onCatalogViewUpdateRequest, this);
        productCatalogApp.off(HPEConstants.catalog.VIEW_UPDATE_RENDER, this.onCatalogViewUpdateRender, this);
        window.removeEventListener('resize', this.onResize);
    },

    /**
     * events
     */
    events: {
        'click .product-listing-overlay': 'onMobileFilterlistClose'
    },

    /**
     * get product results initial min-height
     */
    getHeight: function(el) {
        var h = el.offsetHeight;
        return h;
    },

    /**
     * cache value of product list offset top
     */
    cacheOffsetTop: function() {
        var offsetTop = this.getOffsetTop(this.productListContainer);
        this.offsetTop = (offsetTop > 0) ? offsetTop : 0;
    },

    /**
     * determine the scroll offet top of container element from viewport top
     * @param {object} el element to find the top offset
     * @return {number} pixels from top of viewport
     */
    getOffsetTop: function(el) {
        var y = 0;
        while (el && el.offsetTop) {
            y += (el.offsetTop - this.navListHeight);
            el = el.offsetParent;
        }

        return y;
    },

    /**
     * try to optimize DOM access
     * may be called multiple times before this.el is present depending on how rendered
     */
    viewCachingInitialize: function() {

        //only initialize caching once
        if (this.el && (!this.hasInitializedViewCaching)) {

            //cache elements that exist from AEM/sightly at initialization time
            this.cacheElements({
                productCardResults: '.plp-product-results',
                productListContainer: '.product-listing-tab'
            });

            //In the case of a tab instance, store the height of the tab nav.
            if (productCatalogApp.isTabInstance) {
                this.navListHeight = document.querySelector('.dynamic-tab-container-nav').offsetHeight;
            } else {
                this.navListHeight = 0;
            }

            //save initial height of product card results container
            this.model.minHeight = this.getHeight(this.productCardResults);

            //cache value of the top of the element from the viewport top
            this.cacheOffsetTop();

            this.hasInitializedViewCaching = true;
        }
    },

    /**
     * handle catalog view update request event
     */
    onCatalogViewUpdateRequest: function() {
      HPESpinner.show();
    },

    /**
     * handle catalog view render event
     */
    onCatalogViewUpdateRender: function() {

        //store refrences for jQuery Animate
        var elements = document.querySelectorAll('html, body');
        var windowWidth = window.outerWidth;
        var YOffset = window.scrollY;

        //if mobile, overwrite element to be animated
        if (windowWidth < 768 && document.querySelector('.hpe-product-detail-page')) {
            elements = document.querySelector('#dynamic-tab-container-panel');
            YOffset = elements.scrollTop;
        }

        //loading state is now complete
        this.model.isLoading = false;
        this.model.minHeight = null;

        //refresh filter scrolling UI
        this.filters.refresh();

        //scroll to top of container with animation if needed, easier animation with jQuery
        //broadcast start and end events
        if (YOffset > this.offsetTop) {
            productCatalogApp.trigger(HPEConstants.catalog.CATALOG_SCROLL_TOP_CHANGE, { busy: true });
            $(elements).animate({
                scrollTop: this.offsetTop
            }, 500, 'swing', function() {
                productCatalogApp.trigger(HPEConstants.catalog.CATALOG_SCROLL_TOP_CHANGE, { busy: false });
            });
        }
    },

    /**
     * handle click to close mobile filter navigation
     * @param {object} e event object
     */
    onMobileFilterlistClose: function(e) {
        this.filters.onMobileFilterlistClose(e);
    },

    /**
     * handle window resize event
     */
    onWindowResize: function() {

        var that = this;

        //update offset top cache after resize
        clearTimeout(this.resizeTimeout);
        //this.resizeTimeout = setTimeout(this.cacheOffsetTop.bind(this), 500);
        this.resizeTimeout = setTimeout(function() {
            that.cacheOffsetTop();
            that.filters.refresh();
        }, 300);
    },

    /**
     * subview definitions
     */
    subviews: {
        pagination: {
            selector: '[data-hook=productlist-pagination]',
            // waitFor: 'productCatalogApp.pagination',
            prepareView: function(el) {
                return new PaginationView({
                    el: el,
                    model: productCatalogApp.pagination
                });
            }
        },
        paginationUtilityBar: {
            selector: '[data-hook=productlist-pagination-utilitybar]',
            // waitFor: 'productCatalogApp.pagination',
            prepareView: function(el) {
                return new PaginationView({
                    el: el,
                    model: productCatalogApp.pagination
                });
            }
        },
        utilitybar: {
            selector: '[data-hook=productlist-utilitybar]',
            //waitFor: 'productCatalogApp.utilitybar',
            prepareView: function(el) {
                return new UtilityBarView({
                    el: el,
                    model: productCatalogApp.utilitybar
                });
            }
        },
        productcard: {
            selector: '[data-hook=productlist-productcard]',
            //waitFor: 'productCatalogApp.productcard',
            prepareView: function() {
                this.query('.plp-product-results').innerHTML = '';
                return this.renderCollection(productCatalogApp.productcard, ProductCardView, this.query('.plp-product-results'));
            }
        },
        filters: {
            selector: '.filterslist-catalog',
            // waitFor: 'productCatalogApp.filters',
            prepareView: function(el) {
                return new FiltersView({
                    el: el,
                    model: productCatalogApp.filters
                });
            }
        },
        breadcrumbs: {
            selector: '[data-hook=filter-breadcrumbs]',
            // waitFor: 'productCatalogApp.breadcrumbs',
            prepareView: function(el) {
                return new BreadcrumbsView({
                    el: el,
                    model: productCatalogApp.breadcrumbs
                });
            }
        }
    },

    /**
     * bindings
     */
    bindings: {
        'model.isLoading': {
            type: 'booleanClass',
            selector: '.product-listing-tab',
            name: 'loading'
        },
        'model.isErrorMode': {
            type: 'booleanClass',
            selector: '.product-listing-tab',
            name: 'catalog-error'
        },
        'model.minHeight': {
            type: function(el, value) {
                if (value) {
                    el.style.minHeight = value + 'px';
                } else {
                    el.removeAttribute('style');
                }
            },
            hook: 'productlist-productcard'
        },
        'model.tabLabel': {
            type: 'text',
            selector: '.tab-container-headline'
        }
    }
});

module.exports = ProductCatalogView;
